import _objectSpread from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FilterPanel from './components/FilterPanel.vue';
import TheToastNotification from './components/TheToastNotification.vue';
import TheCart from './components/TheCart.vue';
import TheSearch from './components/TheSearch.vue';
import Login from './components/Login.vue';
import CreateAccount from './components/CreateAccount.vue';
import ForgotPassword from './components/ForgotPassword.vue';
import TheCookieNotification from './components/TheCookieNotification.vue';
import Url from "url-parse";
import queryString from "query-string"; //import Account from './components/Account.vue';

import { mapState } from 'vuex';
import get from 'lodash/get';
import { getFilterStateFromQuery } from './modules/swell'; // Calculate product limit from category rows/cols

function getProductLimit(category) {
  return ~~get(category, 'content.productRows', 4) * ~~get(category, 'content.productCols', 6);
}

export default {
  name: 'App',
  components: {
    TheToastNotification: TheToastNotification,
    Login: Login,
    TheCookieNotification: TheCookieNotification,
    TheCart: TheCart,
    TheSearch: TheSearch,
    ForgotPassword: ForgotPassword,
    CreateAccount: CreateAccount,
    FilterPanel: FilterPanel
  },
  data: function data() {
    return {
      slug: undefined,
      category: undefined,
      products: undefined,
      productsCount: 0,
      filters: [],
      filterState: {},
      pages: {},
      page: 1,
      limit: 24,
      sortMode: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var $swell, url, query, category, products;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              $swell = _this.$swell;
              url = new Url(window.location);
              console.log(url);
              query = queryString.parse((url.query || "").replace(/^\?/g, ""));
              _this.slug = url.pathname.match(/^\/products\/[^/]+/g) ? url.pathname.replace("/products/", "") : ""; // Parse URL query params

              _this.page = parseInt(query.page) || 1;
              _this.sortMode = query.sort || ''; // Set data for the skeleton loader (as many products as we're going to fetch)

              _this.products = _toConsumableArray(Array(_this.limit).keys()).map(function () {
                return {};
              }); // First fetch both the category and unfiltered products (so we get a complete list of filters)

              _context.next = 10;
              return $swell.categories.get(_this.slug);

            case 10:
              category = _context.sent;

              if (category) {
                _context.next = 14;
                break;
              }

              console.log("filter errror");
              return _context.abrupt("return");

            case 14:
              // Set limit from category settings
              _this.limit = getProductLimit(category); // Fetch unfiltered products

              _context.next = 17;
              return _this.fetchProducts();

            case 17:
              products = _context.sent;
              // Set category and filter data
              _this.category = category;
              _context.next = 21;
              return $swell.products.filterableAttributeFilters(products);

            case 21:
              _this.filters = _context.sent;
              _this.filterState = getFilterStateFromQuery(query, _this.filters); // If there's a filter query, get filtered products

              if (!_this.activeFilterCount) {
                _context.next = 27;
                break;
              }

              _context.next = 26;
              return _this.fetchProducts(_this.filterState, _this.filters);

            case 26:
              products = _context.sent;

            case 27:
              _this.setProducts(products);

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread(_objectSpread({}, mapState(['currency', 'notification', 'cartIsActive', 'customer', 'addedItem', 'customerLoggedIn', 'filterModalIsVisible', 'cookieNotificationIsActive', 'searchIsActive', 'loginIsActive', 'forgotPasswordIsActive', 'createAccountIsActive', 'cookiesAreAccepted', 'filterModalIsVisible'])), {}, {
    settings: function settings() {
      return get(this, 'category.content', {});
    },
    activeFilterCount: function activeFilterCount() {
      return Object.keys(this.filterState).length;
    }
  }),
  methods: {
    fetchProducts: function fetchProducts(filterState) {
      var $swell = this.$swell,
          page = this.page,
          limit = this.limit,
          sortMode = this.sortMode,
          slug = this.slug;
      return $swell.products.list({
        page: page,
        limit: limit,
        sort: typeof sortMode.value === 'undefined' ? sortMode : sortMode.value,
        categories: slug,
        $filters: filterState,
        expand: ['variants']
      });
    },
    setProducts: function setProducts(products) {
      this.pages = products.pages;
      this.products = products.results;
      this.productsCount = products.count;
    },
    updateProductsFiltered: function updateProductsFiltered() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var $route, products;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $route = _this2.$route; // Parse URL query params

                _this2.page = parseInt($route.query.page) || 1;
                _this2.sortMode = $route.query.sort || '';
                _this2.filterState = getFilterStateFromQuery($route.query, _this2.filters);
                _context2.next = 6;
                return _this2.fetchProducts(_this2.filterState, _this2.filters);

              case 6:
                products = _context2.sent;

                _this2.setProducts(products);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    updateFilters: function updateFilters(filterState) {
      this.updateRouteQuery(filterState);
    },
    updateSortMode: function updateSortMode(option) {
      this.updateRouteQuery(_objectSpread(_objectSpread({}, this.filterState), {}, {
        sort: typeof option.value === 'undefined' ? option : option.value
      }));
    },
    updateRouteQuery: function updateRouteQuery(filters) {
      var url = new Url(window.location);
      console.log(url);
      var query = queryString.parse((url.query || "").replace(/^\?/g, ""));
      var keys = Object.keys(filters);
      keys.forEach(function (key) {
        query[key] = filters[key];
      });
      window.location.href = url.origin + url.pathname + "?" + queryString.stringify(query); // console.log("update query")
    }
  }
};